export var BatchMode;
(function (BatchMode) {
    BatchMode["BATCH_MODE_STREAMING"] = "streaming";
    BatchMode["BATCH_MODE_MICRO_BATCH"] = "micro_batch";
})(BatchMode || (BatchMode = {}));
